import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

export const OtherCompetitorsCell = ({ onClick, children }: PropsWithChildren<{ onClick: () => void }>) => (
    <Text
        as="button"
        className="keep-on-print"
        border="none"
        background="transparent"
        onClick={onClick}
        fontVariant="body2"
        color={colorsPalettes.blue[400]}
        cursor="pointer"
    >
        {children}
    </Text>
);
